module.exports = __webpack_public_path__ + "img/plowing.974cf648.jpg";